
import { drawPointsAnim, drawAngleAnim, drawLineAnim, drawCircleAnim, rotateCircleAnim, addCustomDelay } from "../../../../../../src/animation/Circle/helpers/drawHelpers";
import { INITIAL_RADIANS } from "../../types/Config";
import { normalizeRadian } from "../../../../../../src/utils/math/normalizeRadian";
import { ContextType } from "../../types/Interface";


export async function runCircleAnimation(context:ContextType, onComp: () => void) {
	const {
		circle,
		LineManager,
		PointManager,
		AngleManager,
		cCoord,
	} = context;

	const centerPoint = PointManager.getPoints()[0];
	const centerPointCoord = PointManager.getPointsCoord()[0];
	const pointsCoord = PointManager.getRedPointsCoord();
	const chordPoints = PointManager.getInitialChordPoints();
	const RedPoints = PointManager.getRedPoints();
	const initialRadian = PointManager.getInitialRadians();
	const angles = AngleManager.getAngles();

	AngleManager.draw(chordPoints);
	circle.setRadians([INITIAL_RADIANS[0], INITIAL_RADIANS[0]]);

	drawPointsAnim([centerPoint]);
	await drawCircleAnim(circle, INITIAL_RADIANS[0] + Math.PI * 2, 0, true, cCoord);
	await drawLineAnim(LineManager.lines[2], centerPointCoord, pointsCoord[0]);
	await drawLineAnim(LineManager.lines[0], chordPoints[0], chordPoints[2]);

	LineManager.lines[0].draw(chordPoints[0], chordPoints[1]);
	LineManager.lines[1].draw(chordPoints[1], chordPoints[2]);
	await addCustomDelay(500);

	LineManager.lines[0].setVisibleOfEqualSymbol(true);
	LineManager.lines[1].setVisibleOfEqualSymbol(true);

	await addCustomDelay(200);
	await drawAngleAnim(angles[0], "x");
	await rotateCircleAnim((v) => PointManager.setRadian([{ pTag: RedPoints[0].tag, radian: normalizeRadian(initialRadian[0] + v) }]));
	await drawPointsAnim(RedPoints);

	onComp();
}